import { Binding, GraphObject, Margin, Panel, Spot, TextBlock } from 'gojs';
import {
  dataLineageDiagramConfig,
  DataLineageUINode,
  LINEAGE_PARTS,
} from '../../../../../../state/data-lineage-diagram';
import { tableColumnsButton } from '../../shared/parts/buttons/columns-button';
import { tableButton } from '../../shared/parts/buttons/table-button';

const $ = GraphObject.make;

export const nodeDetails = (props: Record<string, unknown> = {}, bindings: Binding[] = []) =>
  $(
    Panel,
    Panel.Horizontal,
    {
      padding: new Margin(10, 5),
      alignment: Spot.Left,
      ...props,
    },
    columnsPanel(),
    tableButton(),
    ...bindings,
  );

const columnsPanel = (props: Record<string, unknown> = {}, bindings: Binding[] = []) =>
  $(
    Panel,
    Panel.Horizontal,
    {
      width: 250,
      ...props,
    },
    textBlock([columnsCountBinding()]),
    tableColumnsButton([columnsButtonVisibilityBinding()]),
    ...bindings,
  );

const textBlock = (bindings: Binding[] = []) =>
  $(
    TextBlock,
    {
      name: LINEAGE_PARTS.NODE_COLUMNS_NUMBER,
      overflow: TextBlock.OverflowClip,
      margin: new Margin(0, 5),
      alignment: Spot.Left,
      font: `${dataLineageDiagramConfig.font.style} ${dataLineageDiagramConfig.font.size.regular} ${dataLineageDiagramConfig.font.family}`,
      stroke: dataLineageDiagramConfig.colors.grey,
    },
    ...bindings,
  );

const columnsCountBinding = () =>
  new Binding('text', '', (node: DataLineageUINode) => {
    return `${node.validColumnsCount ?? 0} Columns`;
  });

const columnsButtonVisibilityBinding = () =>
  new Binding('visible', '', (node: DataLineageUINode) => !!node.validColumnsCount);
